<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Visit note
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.primary--text.pa-6
      div.text-xs.font-medium.neutral700--text Visit note
      v-textarea.round-xl.mt-3(v-model="note" placeholder="Enter visit note..." outlined hide-details rows="4" auto-grow)

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="saveData" :loading="isLoading" color="primary" depressed) {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    isLoading: false,
    note: null,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      leadPid: 'treatment/getLeadPid',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.consultation.case) {
      this.note = this.consultation.case
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isLoading = true
      const params = { case: this.note }
      this.$axios.patch(`/clinics/${this.company.slug}/consultations/${this.leadPid}`, params)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.$store.commit('treatment/updateConsultation', { case: resp.data.case })
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
